import { ICommand } from '@chainlit/react-client';

export type AgentDebugView = 'full' | 'context';

export interface LocalCommand extends ICommand {
    view: AgentDebugView;
}

export const LOCAL_COMMANDS: LocalCommand[] = [
    {
        id: '/context',
        icon: 'square-slash',
        description: 'Show context usage, request history and session cost.',
        view: 'context'
    },
    {
        id: '/agent_debug',
        icon: 'square-slash',
        description:
            'Show everything the agent sees — mode, model, tools, and the full system prompt.',
        view: 'full'
    }
];

export const findLocalCommand = (typed: string) =>
    LOCAL_COMMANDS.find((command) => command.id === typed.trim().toLowerCase());

export const isLocalCommand = (
    command: ICommand
): command is LocalCommand => 'view' in command;
